<script>
/* eslint-disable camelcase */
import Axios from 'axios'

const isProduction = process.env.NODE_ENV === 'production'

const base_url = isProduction
  ? 'https://nfu.co.kr:6161/'
  : 'http://localhost:6161/'

export const base_url_export = isProduction
  ? 'https://nfu.co.kr:6161/'
  : 'http://localhost:6161/'

const base_homepage_url = isProduction
  ? 'https://nfu.co.kr/'
  : 'http://localhost:3000/'

export const base_homepage_url_export = isProduction
  ? 'https://nfu.co.kr/'
  : 'http://localhost:3000/'

export const inicis_export = isProduction
  ? 'html5_inicis.MOInfu0001'
  : 'html5_inicis.INIpayTest'

export const buildStatus = isProduction
  ? 'operation'
  : 'test'

export const defaultFunction = () => {
  return ''
}

/**
 * 네이버페이 SDK에 필요한 공개 버튼 설정만 서버에서 조회한다.
 * 가맹점 인증키는 이 함수나 프론트엔드에 노출하지 않는다.
 */
export const get_naver_pay_button_config = async () => {
  try {
    const response = await Axios.get(`${base_url}naver-pay/button-config`, {
      withCredentials: true
    })
    return response.data
  } catch (err) {
    console.error(err)
    return null
  }
}

/**
 * 네이버페이 주문등록은 서버에서 상품 가격과 옵션을 검증한 뒤 수행한다.
 * 응답은 { buyKey, merchantNo }이며, 버튼 SDK용 { key, merchantNo } 변환은 NaverPayButton.vue에서 한다.
 * backUrl은 유입 추적 파라미터(NaPm 등)를 제거한 주소를 전달해야 한다. (서버에서도 한 번 더 정리)
 */
export const register_naver_pay_order = async ({
  buyList,
  backUrl,
  naverInflowCode,
  saClickId
}) => {
  const data = new FormData()
  data.append('buy_list_array', JSON.stringify(buyList))
  data.append('back_url', backUrl)
  data.append('naver_inflow_code', naverInflowCode)
  data.append('sa_click_id', saClickId)

  try {
    const response = await Axios.post(`${base_url}naver-pay/register-order`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true
    })
    return response.data
  } catch (err) {
    const message = err.response && err.response.data && err.response.data.message
      ? err.response.data.message
      : '네이버페이 주문을 시작하지 못했습니다.'
    alert(message)
    throw err
  }
}

/* 관리자 분야 */
export const check_login_admin = async (
  admin_login_ID,
  admin_password
) => {
  let data = new FormData()

  data.append('admin_login_ID', admin_login_ID)
  data.append('admin_password', admin_password)

  try {
    const response = await Axios.post(
      `${base_url}login/check_login_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_session_admin = async () => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}login/get_session_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_rolling_banner = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_rolling_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_rolling_banner_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_rolling_banner_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_rolling_banner_one = async (
  rolling_banner_ID
) => {
  let data = new FormData()
  data.append('rolling_banner_ID', rolling_banner_ID)
  try {
    const response = await Axios.post(
      `${base_url}main/get_rolling_banner_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_rolling_banner = async (
  rolling_banner_name,
  rolling_banner_image,
  rolling_banner_image_mobile,
  rolling_banner_link
) => {
  let data = new FormData()
  data.append('rolling_banner_name', rolling_banner_name)
  data.append('rolling_banner_image', rolling_banner_image)
  data.append('rolling_banner_image_mobile', rolling_banner_image_mobile)
  data.append('rolling_banner_link', rolling_banner_link)

  try {
    const response = await Axios.post(
      `${base_url}main/insert_rolling_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_rolling_banner = async (
  rolling_banner_ID,
  rolling_banner_name,
  rolling_banner_image,
  rolling_banner_image_mobile,
  rolling_banner_link,
  rolling_banner_status
) => {
  let data = new FormData()
  data.append('rolling_banner_ID', rolling_banner_ID)
  data.append('rolling_banner_name', rolling_banner_name)
  data.append('rolling_banner_image', rolling_banner_image)
  data.append('rolling_banner_image_mobile', rolling_banner_image_mobile)
  data.append('rolling_banner_link', rolling_banner_link)
  data.append('rolling_banner_status', rolling_banner_status)

  try {
    const response = await Axios.post(
      `${base_url}main/update_rolling_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_rolling_banner_order = async (
  rolling_banner_order_array
) => {
  let data = new FormData()

  data.append('rolling_banner_order_array', JSON.stringify(rolling_banner_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_rolling_banner_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_rolling_banner = async (
  rolling_banner_ID_array
) => {
  let data = new FormData()
  data.append('rolling_banner_ID_array', rolling_banner_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_rolling_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_instock = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_instock`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_instock_main_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_instock_main_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_instock_search = async (
  search_input_data
) => {
  let data = new FormData()
  data.append('search_input_data', search_input_data)

  try {
    const response = await Axios.post(
      `${base_url}main/get_instock_search`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_instock_one = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/insert_instock_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_instock = async (
  instock_ID,
  product_ID
) => {
  let data = new FormData()

  data.append('instock_ID', instock_ID)
  data.append('product_ID', String(product_ID))

  try {
    const response = await Axios.post(
      `${base_url}main/update_instock`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_instock_status = async (
  instock_ID,
  instock_status
) => {
  let data = new FormData()

  data.append('instock_ID', instock_ID)
  data.append('instock_status', String(instock_status))

  try {
    const response = await Axios.post(
      `${base_url}main/update_instock_status`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_instock_order = async (
  instock_order_array
) => {
  let data = new FormData()

  data.append('instock_order_array', JSON.stringify(instock_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_instock_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_instock = async (
  instock_ID_array
) => {
  let data = new FormData()
  data.append('instock_ID_array', instock_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_instock`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_nfu_pick = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_nfu_pick`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_nfu_pick_main_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_nfu_pick_main_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_nfu_pick_search = async (
  search_input_data
) => {
  let data = new FormData()
  data.append('search_input_data', search_input_data)

  try {
    const response = await Axios.post(
      `${base_url}main/get_nfu_pick_search`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_nfu_pick_one = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/insert_nfu_pick_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_nfu_pick = async (
  nfu_pick_ID,
  product_ID
) => {
  let data = new FormData()

  data.append('nfu_pick_ID', nfu_pick_ID)
  data.append('product_ID', String(product_ID))

  try {
    const response = await Axios.post(
      `${base_url}main/update_nfu_pick`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_nfu_pick_status = async (
  nfu_pick_ID,
  nfu_pick_status
) => {
  let data = new FormData()

  data.append('nfu_pick_ID', nfu_pick_ID)
  data.append('nfu_pick_status', String(nfu_pick_status))

  try {
    const response = await Axios.post(
      `${base_url}main/update_nfu_pick_status`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_nfu_pick_order = async (
  nfu_pick_order_array
) => {
  let data = new FormData()

  data.append('nfu_pick_order_array', JSON.stringify(nfu_pick_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_nfu_pick_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_nfu_pick = async (
  nfu_pick_ID_array
) => {
  let data = new FormData()
  data.append('nfu_pick_ID_array', nfu_pick_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_nfu_pick`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_monthly_best = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_monthly_best`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_monthly_best_main_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_monthly_best_main_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_monthly_best_search = async (
  search_input_data
) => {
  let data = new FormData()
  data.append('search_input_data', search_input_data)

  try {
    const response = await Axios.post(
      `${base_url}main/get_monthly_best_search`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_monthly_best_one = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/insert_monthly_best_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_monthly_best = async (
  monthly_best_ID,
  product_ID
) => {
  let data = new FormData()

  data.append('monthly_best_ID', monthly_best_ID)
  data.append('product_ID', String(product_ID))

  try {
    const response = await Axios.post(
      `${base_url}main/update_monthly_best`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_monthly_best_status = async (
  monthly_best_ID,
  monthly_best_status
) => {
  let data = new FormData()

  data.append('monthly_best_ID', monthly_best_ID)
  data.append('monthly_best_status', String(monthly_best_status))

  try {
    const response = await Axios.post(
      `${base_url}main/update_monthly_best_status`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_monthly_best_order = async (
  monthly_best_order_array
) => {
  let data = new FormData()

  data.append('monthly_best_order_array', JSON.stringify(monthly_best_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_monthly_best_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_monthly_best = async (
  monthly_best_ID_array
) => {
  let data = new FormData()
  data.append('monthly_best_ID_array', monthly_best_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_monthly_best`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_menu_permission = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}system/get_menu_permission`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_menu_permission_one = async (
  menu_permission_ID
) => {
  let data = new FormData()
  data.append('menu_permission_ID', menu_permission_ID)
  try {
    const response = await Axios.post(
      `${base_url}system/get_menu_permission_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_menu_permission_status_1 = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}system/get_menu_permission_status_1`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_menu_permission = async (
  menu_permission_name,
  menu_permission_status,
  menu_permission_array
) => {
  let data = new FormData()
  data.append('menu_permission_name', menu_permission_name)
  data.append('menu_permission_status', menu_permission_status)
  data.append('menu_permission_array', menu_permission_array)

  try {
    const response = await Axios.post(
      `${base_url}system/insert_menu_permission`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_menu_permission = async (
  menu_permission_ID,
  menu_permission_name,
  menu_permission_status,
  menu_permission_array
) => {
  let data = new FormData()
  data.append('menu_permission_ID', menu_permission_ID)
  data.append('menu_permission_name', menu_permission_name)
  data.append('menu_permission_status', menu_permission_status)
  data.append('menu_permission_array', menu_permission_array)

  try {
    const response = await Axios.post(
      `${base_url}system/update_menu_permission`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_admin = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}system/get_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_admin_one = async (
  admin_ID
) => {
  let data = new FormData()
  data.append('admin_ID', admin_ID)
  try {
    const response = await Axios.post(
      `${base_url}system/get_admin_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_admin = async (
  menu_permission_ID_admin,
  admin_login_ID,
  admin_password,
  admin_name,
  admin_activate
) => {
  let data = new FormData()
  data.append('menu_permission_ID_admin', menu_permission_ID_admin)
  data.append('admin_login_ID', admin_login_ID)
  data.append('admin_password', admin_password)
  data.append('admin_name', admin_name)
  data.append('admin_activate', admin_activate)

  try {
    const response = await Axios.post(
      `${base_url}system/insert_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_admin = async (
  admin_ID,
  menu_permission_ID_admin,
  admin_login_ID,
  admin_password,
  admin_name,
  admin_activate
) => {
  let data = new FormData()
  data.append('admin_ID', admin_ID)
  data.append('menu_permission_ID_admin', menu_permission_ID_admin)
  data.append('admin_login_ID', admin_login_ID)
  data.append('admin_password', admin_password)
  data.append('admin_name', admin_name)
  data.append('admin_activate', admin_activate)

  try {
    const response = await Axios.post(
      `${base_url}system/update_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const check_customer_login_ID = async (
  customer_login_ID
) => {
  let data = new FormData()

  data.append('customer_login_ID', customer_login_ID)

  try {
    const response = await Axios.post(
      `${base_url}login/check_customer_login_ID`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_customer = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}login/get_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_customer_one = async (
  customer_ID
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  try {
    const response = await Axios.post(
      `${base_url}login/get_customer_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_customer_search = async (
  search_input_data
) => {
  let data = new FormData()
  data.append('search_input_data', search_input_data)
  try {
    const response = await Axios.post(
      `${base_url}login/get_customer_search`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_customer = async (
  customer_login_ID,
  customer_password,
  customer_name,
  customer_phone_number,
  customer_email,
  customer_gender,
  customer_zip_code,
  customer_road_address,
  customer_detail_address,
  customer_big_area,
  customer_small_area,
  customer_privacy_status,
  customer_service_agreement_status,
  customer_marketing_status
) => {
  let data = new FormData()

  data.append('customer_login_ID', customer_login_ID)
  data.append('customer_password', customer_password)
  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)
  data.append('customer_email', customer_email)
  data.append('customer_gender', customer_gender)
  data.append('customer_zip_code', customer_zip_code)
  data.append('customer_road_address', customer_road_address)
  data.append('customer_detail_address', customer_detail_address)
  data.append('customer_big_area', customer_big_area)
  data.append('customer_small_area', customer_small_area)
  data.append('customer_privacy_status', customer_privacy_status)
  data.append('customer_service_agreement_status', customer_service_agreement_status)
  data.append('customer_marketing_status', customer_marketing_status)

  try {
    const response = await Axios.post(
      `${base_url}login/insert_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_customer = async (
  customer_ID,
  customer_login_ID,
  customer_password,
  customer_name,
  customer_phone_number,
  customer_email,
  customer_gender,
  customer_zip_code,
  customer_road_address,
  customer_detail_address,
  customer_big_area,
  customer_small_area,
  customer_activate
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  data.append('customer_login_ID', customer_login_ID)
  data.append('customer_password', customer_password)
  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)
  data.append('customer_email', customer_email)
  data.append('customer_gender', customer_gender)
  data.append('customer_zip_code', customer_zip_code)
  data.append('customer_road_address', customer_road_address)
  data.append('customer_detail_address', customer_detail_address)
  data.append('customer_big_area', customer_big_area)
  data.append('customer_small_area', customer_small_area)
  data.append('customer_activate', customer_activate)

  try {
    const response = await Axios.post(
      `${base_url}login/update_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_customer_homepage = async (
  customer_ID,
  customer_password,
  customer_name,
  customer_phone_number,
  customer_email,
  customer_gender,
  customer_zip_code,
  customer_road_address,
  customer_detail_address,
  customer_big_area,
  customer_small_area,
  customer_marketing_status
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  data.append('customer_password', customer_password)
  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)
  data.append('customer_email', customer_email)
  data.append('customer_gender', customer_gender)
  data.append('customer_zip_code', customer_zip_code)
  data.append('customer_road_address', customer_road_address)
  data.append('customer_detail_address', customer_detail_address)
  data.append('customer_big_area', customer_big_area)
  data.append('customer_small_area', customer_small_area)
  data.append('customer_marketing_status', customer_marketing_status)

  try {
    const response = await Axios.post(
      `${base_url}login/update_customer_homepage`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_customer_easy_join = async (
  customer_ID,
  customer_name,
  customer_phone_number,
  customer_email,
  customer_zip_code,
  customer_road_address,
  customer_detail_address,
  customer_big_area,
  customer_small_area,
  customer_privacy_status,
  customer_service_agreement_status,
  customer_marketing_status
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)
  data.append('customer_email', customer_email)
  data.append('customer_zip_code', customer_zip_code)
  data.append('customer_road_address', customer_road_address)
  data.append('customer_detail_address', customer_detail_address)
  data.append('customer_big_area', customer_big_area)
  data.append('customer_small_area', customer_small_area)
  data.append('customer_privacy_status', customer_privacy_status)
  data.append('customer_service_agreement_status', customer_service_agreement_status)
  data.append('customer_marketing_status', customer_marketing_status)

  try {
    const response = await Axios.post(
      `${base_url}login/update_customer_easy_join`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const check_login = async (
  customer_login_ID,
  customer_password
) => {
  let data = new FormData()

  data.append('customer_login_ID', customer_login_ID)
  data.append('customer_password', customer_password)

  try {
    const response = await Axios.post(
      `${base_url}login/check_login`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_kakao_token = async (code) => {
  try {
    const response = await Axios.post(
      `https://kauth.kakao.com/oauth/token`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        params: {
          grant_type: 'authorization_code',
          client_id: 'fe341811021a94effc6d23e8efe40641',
          code: code,
          redirect_uri: base_homepage_url + 'KaKaoLogin'
        }
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_kakao_login_data = async (token) => {
  try {
    const response = await Axios.post(
      'https://kapi.kakao.com/v2/user/me',
      {},
      {
        headers: {
          Authorization: `Bearer ${token.access_token}`
        }
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const check_kakao_login = async (
  customer_kakao_ID,
  customer_email,
  customer_name
) => {
  let data = new FormData()
  data.append('customer_kakao_ID', customer_kakao_ID)
  data.append('customer_email', customer_email)
  data.append('customer_name', customer_name)

  try {
    const response = await Axios.post(
      `${base_url}login/check_kakao_login`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_naver_token = async (code) => {
  let data = new FormData()
  data.append('code', code)

  try {
    const response = await Axios.post(
      `${base_url}login/get_naver_token`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const search_customer = async (
  customer_login_ID,
  customer_name,
  customer_email,
  search_status
) => {
  let data = new FormData()

  data.append('customer_login_ID', customer_login_ID)
  data.append('customer_name', customer_name)
  data.append('customer_email', customer_email)
  data.append('search_status', search_status)

  try {
    const response = await Axios.post(
      `${base_url}login/search_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const send_temp_password = async (
  customer_ID,
  customer_email
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  data.append('customer_email', customer_email)

  try {
    const response = await Axios.post(
      `${base_url}login/send_temp_password`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_session_customer = async (
) => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}login/get_session_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_session_customer = async (
) => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}login/delete_session_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_brand = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_brand`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_brand_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_brand_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_brand_one = async (
  brand_ID
) => {
  let data = new FormData()
  data.append('brand_ID', brand_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_brand_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_brand = async (
  brand_kor_name,
  brand_eng_name,
  brand_banner_image,
  brand_logo_image,
  brand_logo_hover,
  brand_explnation
) => {
  let data = new FormData()
  data.append('brand_kor_name', brand_kor_name)
  data.append('brand_eng_name', brand_eng_name)
  data.append('brand_banner_image', brand_banner_image)
  data.append('brand_logo_image', brand_logo_image)
  data.append('brand_logo_hover', brand_logo_hover)
  data.append('brand_explnation', brand_explnation)

  try {
    const response = await Axios.post(
      `${base_url}product/insert_brand`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_brand = async (
  brand_ID,
  brand_kor_name,
  brand_eng_name,
  brand_banner_image,
  brand_logo_image,
  brand_logo_hover,
  brand_explnation,
  brand_activate
) => {
  let data = new FormData()
  data.append('brand_ID', brand_ID)
  data.append('brand_kor_name', brand_kor_name)
  data.append('brand_eng_name', brand_eng_name)
  data.append('brand_banner_image', brand_banner_image)
  data.append('brand_logo_image', brand_logo_image)
  data.append('brand_logo_hover', brand_logo_hover)
  data.append('brand_explnation', brand_explnation)
  data.append('brand_activate', brand_activate)

  try {
    const response = await Axios.post(
      `${base_url}product/update_brand`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_brand_order = async (
  brand_order_array
) => {
  let data = new FormData()

  data.append('brand_order_array', JSON.stringify(brand_order_array))
  try {
    const response = await Axios.post(
      `${base_url}product/update_brand_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_type = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_type`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_type_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_type_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_type_one = async (
  product_type_ID
) => {
  let data = new FormData()
  data.append('product_type_ID', product_type_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_type_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_product_type = async (
  product_type_kor_name,
  product_type_eng_name
) => {
  let data = new FormData()
  data.append('product_type_kor_name', product_type_kor_name)
  data.append('product_type_eng_name', product_type_eng_name)

  try {
    const response = await Axios.post(
      `${base_url}product/insert_product_type`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_product_type = async (
  product_type_ID,
  product_type_kor_name,
  product_type_eng_name,
  product_type_activate
) => {
  let data = new FormData()
  data.append('product_type_ID', product_type_ID)
  data.append('product_type_kor_name', product_type_kor_name)
  data.append('product_type_eng_name', product_type_eng_name)
  data.append('product_type_activate', product_type_activate)

  try {
    const response = await Axios.post(
      `${base_url}product/update_product_type`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_product_type_order = async (
  product_type_order_array
) => {
  let data = new FormData()

  data.append('product_type_order_array', JSON.stringify(product_type_order_array))
  try {
    const response = await Axios.post(
      `${base_url}product/update_product_type_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_one_level = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_one_level`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_one_level_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_one_level_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_one_level_one = async (
  product_division_one_level_ID
) => {
  let data = new FormData()
  data.append('product_division_one_level_ID', product_division_one_level_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_one_level_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_one_level_one_product_type = async (
  product_type_ID
) => {
  let data = new FormData()
  data.append('product_type_ID', product_type_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_one_level_one_product_type`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_one_level_one_product_type_use = async (
  product_type_ID
) => {
  let data = new FormData()
  data.append('product_type_ID', product_type_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_one_level_one_product_type_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_one_level_brand_ID = async (
  brand_ID_product
) => {
  let data = new FormData()
  data.append('brand_ID_product', brand_ID_product)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_one_level_brand_ID`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_product_division_one_level = async (
  product_type_ID,
  product_division_one_level_kor_name,
  product_division_one_level_eng_name
) => {
  let data = new FormData()
  data.append('product_type_ID', product_type_ID)
  data.append('product_division_one_level_kor_name', product_division_one_level_kor_name)
  data.append('product_division_one_level_eng_name', product_division_one_level_eng_name)

  try {
    const response = await Axios.post(
      `${base_url}product/insert_product_division_one_level`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_product_division_one_level = async (
  product_division_one_level_ID,
  product_type_ID,
  product_division_one_level_kor_name,
  product_division_one_level_eng_name,
  product_division_one_level_activate
) => {
  let data = new FormData()
  data.append('product_division_one_level_ID', product_division_one_level_ID)
  data.append('product_type_ID', product_type_ID)
  data.append('product_division_one_level_kor_name', product_division_one_level_kor_name)
  data.append('product_division_one_level_eng_name', product_division_one_level_eng_name)
  data.append('product_division_one_level_activate', product_division_one_level_activate)

  try {
    const response = await Axios.post(
      `${base_url}product/update_product_division_one_level`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_product_division_one_level_order = async (
  product_division_one_level_order_array
) => {
  let data = new FormData()

  data.append('product_division_one_level_order_array', JSON.stringify(product_division_one_level_order_array))
  try {
    const response = await Axios.post(
      `${base_url}product/update_product_division_one_level_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_two_level = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_two_level`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_two_level_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_two_level_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_two_level_one = async (
  product_division_two_level_ID
) => {
  let data = new FormData()
  data.append('product_division_two_level_ID', product_division_two_level_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_two_level_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_division_two_level_one_product_division_one_level = async (
  product_division_one_level_ID
) => {
  let data = new FormData()
  data.append('product_division_one_level_ID', product_division_one_level_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_division_two_level_one_product_division_one_level`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_product_division_two_level = async (
  product_division_one_level_ID,
  product_division_two_level_kor_name,
  product_division_two_level_eng_name
) => {
  let data = new FormData()
  data.append('product_division_one_level_ID', product_division_one_level_ID)
  data.append('product_division_two_level_kor_name', product_division_two_level_kor_name)
  data.append('product_division_two_level_eng_name', product_division_two_level_eng_name)

  try {
    const response = await Axios.post(
      `${base_url}product/insert_product_division_two_level`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_product_division_two_level = async (
  product_division_two_level_ID,
  product_division_one_level_ID,
  product_division_two_level_kor_name,
  product_division_two_level_eng_name,
  product_division_two_level_activate
) => {
  let data = new FormData()
  data.append('product_division_two_level_ID', product_division_two_level_ID)
  data.append('product_division_one_level_ID', product_division_one_level_ID)
  data.append('product_division_two_level_kor_name', product_division_two_level_kor_name)
  data.append('product_division_two_level_eng_name', product_division_two_level_eng_name)
  data.append('product_division_two_level_activate', product_division_two_level_activate)

  try {
    const response = await Axios.post(
      `${base_url}product/update_product_division_two_level`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_product_division_two_level_order = async (
  product_division_two_level_order_array
) => {
  let data = new FormData()

  data.append('product_division_two_level_order_array', JSON.stringify(product_division_two_level_order_array))
  try {
    const response = await Axios.post(
      `${base_url}product/update_product_division_two_level_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product = async (params) => {
  let data = new FormData()
  data.append('params', JSON.stringify(params))

  try {
    const response = await Axios.post(
      `${base_url}product/get_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_where = async (
  brand_ID_product,
  product_type_ID_product,
  product_division_one_level_ID_product,
  product_division_two_level_ID_product,
  search_status,
  product_new,
  product_in_stock,
  product_event,
  product_best,
  search
) => {
  let data = new FormData()
  data.append('brand_ID_product', brand_ID_product)
  data.append('product_type_ID_product', product_type_ID_product)
  data.append('product_division_one_level_ID_product', product_division_one_level_ID_product)
  data.append('product_division_two_level_ID_product', product_division_two_level_ID_product)
  data.append('search_status', search_status)
  data.append('product_new', product_new)
  data.append('product_in_stock', product_in_stock)
  data.append('product_event', product_event)
  data.append('product_best', product_best)
  data.append('search', search)

  try {
    const response = await Axios.post(
      `${base_url}product/get_product_where`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_ = async (
  product_ID_product_
) => {
  let data = new FormData()
  data.append('product_ID_product_', product_ID_product_)

  try {
    const response = await Axios.post(
      `${base_url}product/get_product_`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_one = async (
  product_ID
) => {
  let data = new FormData()
  data.append('product_ID', product_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_group_option = async (
  product_ID
) => {
  let data = new FormData()
  data.append('product_ID', product_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_group_option`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_option = async (
  product_ID,
  product_group_option_ID_use_product_option
) => {
  let data = new FormData()
  data.append('product_ID', product_ID)
  data.append('product_group_option_ID_use_product_option', product_group_option_ID_use_product_option)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_option`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_option_list = async (
  product_ID,
  product_group_option_ID_use_product_option
) => {
  let data = new FormData()
  data.append('product_ID', product_ID)
  data.append('product_group_option_ID_use_product_option', product_group_option_ID_use_product_option)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_option_list`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_detail = async (
  product_ID
) => {
  let data = new FormData()
  data.append('product_ID', product_ID)
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_detail`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_product = async (
  brand_ID_product,
  product_type_ID_product,
  product_division_one_level_ID_product,
  product_division_two_level_ID_product,
  product_inventory,
  product_kor_name,
  product_eng_name,
  product_note_title,
  product_video,
  product_video_2,
  product_image,
  product_image_hover,
  product_image_detail,
  product_image_detail_2,
  product_sale_price,
  product_discount,
  product_phone_inquiry_status,
  product_activate,
  product_event,
  product_new,
  product_in_stock,
  product_best,
  product_sale,
  product_expected,
  product_sold_out,
  product_option_status,
  product_group_option_title,
  product_group_option_array,
  product_option_array
) => {
  let data = new FormData()
  data.append('brand_ID_product', brand_ID_product)
  data.append('product_type_ID_product', product_type_ID_product)
  data.append('product_division_one_level_ID_product', product_division_one_level_ID_product)
  data.append('product_division_two_level_ID_product', product_division_two_level_ID_product)
  data.append('product_inventory', product_inventory)
  data.append('product_kor_name', product_kor_name)
  data.append('product_eng_name', product_eng_name)
  data.append('product_note_title', product_note_title)
  data.append('product_video', product_video)
  data.append('product_video_2', product_video_2)
  data.append('product_image', product_image)
  data.append('product_image_hover', product_image_hover)
  data.append('product_image_detail', product_image_detail)
  data.append('product_image_detail_2', product_image_detail_2)
  data.append('product_sale_price', product_sale_price)
  data.append('product_discount', product_discount)
  data.append('product_phone_inquiry_status', product_phone_inquiry_status)
  data.append('product_activate', product_activate)
  data.append('product_event', product_event)
  data.append('product_new', product_new)
  data.append('product_in_stock', product_in_stock)
  data.append('product_best', product_best)
  data.append('product_sale', product_sale)
  data.append('product_expected', product_expected)
  data.append('product_sold_out', product_sold_out)
  data.append('product_option_status', product_option_status)
  data.append('product_group_option_title', product_group_option_title)
  data.append('product_group_option_array', JSON.stringify(product_group_option_array))
  data.append('product_option_array', JSON.stringify(product_option_array))

  try {
    const response = await Axios.post(
      `${base_url}product/insert_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_product = async (
  product_ID,
  brand_ID_product,
  product_type_ID_product,
  product_division_one_level_ID_product,
  product_division_two_level_ID_product,
  product_inventory,
  product_kor_name,
  product_eng_name,
  product_note_title,
  product_video,
  product_video_2,
  product_image,
  product_image_hover,
  product_image_detail,
  product_image_detail_2,
  product_sale_price,
  product_discount,
  product_phone_inquiry_status,
  product_activate,
  product_event,
  product_new,
  product_in_stock,
  product_best,
  product_sale,
  product_expected,
  product_sold_out,
  product_option_status,
  product_group_option_title,
  product_group_option_array,
  product_option_array
) => {
  let data = new FormData()
  data.append('product_ID', product_ID)
  data.append('brand_ID_product', brand_ID_product)
  data.append('product_type_ID_product', product_type_ID_product)
  data.append('product_division_one_level_ID_product', product_division_one_level_ID_product)
  data.append('product_division_two_level_ID_product', product_division_two_level_ID_product)
  data.append('product_inventory', product_inventory)
  data.append('product_kor_name', product_kor_name)
  data.append('product_eng_name', product_eng_name)
  data.append('product_note_title', product_note_title)
  data.append('product_video', product_video)
  data.append('product_video_2', product_video_2)
  data.append('product_image', product_image)
  data.append('product_image_hover', product_image_hover)
  data.append('product_image_detail', product_image_detail)
  data.append('product_image_detail_2', product_image_detail_2)
  data.append('product_sale_price', product_sale_price)
  data.append('product_discount', product_discount)
  data.append('product_phone_inquiry_status', product_phone_inquiry_status)
  data.append('product_activate', product_activate)
  data.append('product_event', product_event)
  data.append('product_new', product_new)
  data.append('product_in_stock', product_in_stock)
  data.append('product_best', product_best)
  data.append('product_sale', product_sale)
  data.append('product_expected', product_expected)
  data.append('product_sold_out', product_sold_out)
  data.append('product_option_status', product_option_status)
  data.append('product_group_option_title', product_group_option_title)
  data.append('product_group_option_array', JSON.stringify(product_group_option_array))
  data.append('product_option_array', JSON.stringify(product_option_array))

  try {
    const response = await Axios.post(
      `${base_url}product/update_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_product_order = async (
  product_order_array
) => {
  let data = new FormData()

  data.append('product_order_array', JSON.stringify(product_order_array))
  try {
    const response = await Axios.post(
      `${base_url}product/update_product_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_product = async (
  product_ID_array
) => {
  let data = new FormData()
  data.append('product_ID_array', product_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}product/delete_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const copy_product = async (
  product_ID_array
) => {
  let data = new FormData()
  data.append('product_ID_array', product_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}product/copy_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_product_select_all = async (
) => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}product/get_product_select_all`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_living_acc = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_living_acc`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_living_acc_main_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_living_acc_main_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_living_acc_search = async (
  search_input_data
) => {
  let data = new FormData()
  data.append('search_input_data', search_input_data)

  try {
    const response = await Axios.post(
      `${base_url}main/get_living_acc_search`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_living_acc_one = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/insert_living_acc_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_living_acc = async (
  living_acc_ID,
  product_ID
) => {
  let data = new FormData()

  data.append('living_acc_ID', living_acc_ID)
  data.append('product_ID', String(product_ID))

  try {
    const response = await Axios.post(
      `${base_url}main/update_living_acc`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_living_acc_status = async (
  living_acc_ID,
  living_acc_status
) => {
  let data = new FormData()

  data.append('living_acc_ID', living_acc_ID)
  data.append('living_acc_status', String(living_acc_status))

  try {
    const response = await Axios.post(
      `${base_url}main/update_living_acc_status`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_living_acc_order = async (
  living_acc_order_array
) => {
  let data = new FormData()

  data.append('living_acc_order_array', JSON.stringify(living_acc_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_living_acc_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_living_acc = async (
  living_acc_ID_array
) => {
  let data = new FormData()
  data.append('living_acc_ID_array', living_acc_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_living_acc`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_styling = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_styling`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_styling_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_styling_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_styling_main_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_styling_main_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_styling_one = async (
  styling_ID
) => {
  let data = new FormData()
  data.append('styling_ID', styling_ID)
  try {
    const response = await Axios.post(
      `${base_url}main/get_styling_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_styling_one_use = async (
  styling_ID
) => {
  let data = new FormData()
  data.append('styling_ID', styling_ID)
  try {
    const response = await Axios.post(
      `${base_url}main/get_styling_one_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_styling = async (
  styling_title,
  styling_sub_title,
  styling_main_image,
  styling_editor,
  styling_editor_mobile,
  styling_status,
  styling_main_status
) => {
  let data = new FormData()
  data.append('styling_title', styling_title)
  data.append('styling_sub_title', styling_sub_title)
  data.append('styling_main_image', styling_main_image)
  data.append('styling_editor', styling_editor)
  data.append('styling_editor_mobile', styling_editor_mobile)
  data.append('styling_status', styling_status)
  data.append('styling_main_status', styling_main_status)

  try {
    const response = await Axios.post(
      `${base_url}main/insert_styling`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_styling = async (
  styling_ID,
  styling_title,
  styling_sub_title,
  styling_main_image,
  styling_editor,
  styling_editor_mobile,
  styling_status,
  styling_main_status
) => {
  let data = new FormData()
  data.append('styling_ID', styling_ID)
  data.append('styling_title', styling_title)
  data.append('styling_sub_title', styling_sub_title)
  data.append('styling_main_image', styling_main_image)
  data.append('styling_editor', styling_editor)
  data.append('styling_editor_mobile', styling_editor_mobile)
  data.append('styling_status', styling_status)
  data.append('styling_main_status', styling_main_status)

  try {
    const response = await Axios.post(
      `${base_url}main/update_styling`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_styling_order = async (
  styling_order_array
) => {
  let data = new FormData()

  data.append('styling_order_array', JSON.stringify(styling_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_styling_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_styling = async (
  styling_ID_array
) => {
  let data = new FormData()
  data.append('styling_ID_array', styling_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_styling`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_editor_image = async (
  editor_file
) => {
  let data = new FormData()
  data.append('editor_file', editor_file.blob())

  try {
    const response = await Axios.post(
      `${base_url}main/insert_editor_image`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return base_url + response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_instagram = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_instagram`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_instagram_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_instagram_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_instagram_main_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_instagram_main_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_instagram_one = async (
  instagram_ID
) => {
  let data = new FormData()
  data.append('instagram_ID', instagram_ID)
  try {
    const response = await Axios.post(
      `${base_url}main/get_instagram_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_instagram_one_use = async (
  instagram_ID
) => {
  let data = new FormData()
  data.append('instagram_ID', instagram_ID)
  try {
    const response = await Axios.post(
      `${base_url}main/get_instagram_one_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_instagram = async (
  instagram_title,
  instagram_link,
  instagram_main_image,
  instagram_status,
  instagram_main_status
) => {
  let data = new FormData()
  data.append('instagram_title', instagram_title)
  data.append('instagram_link', instagram_link)
  data.append('instagram_main_image', instagram_main_image)
  data.append('instagram_status', instagram_status)
  data.append('instagram_main_status', instagram_main_status)

  try {
    const response = await Axios.post(
      `${base_url}main/insert_instagram`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_instagram = async (
  instagram_ID,
  instagram_title,
  instagram_link,
  instagram_main_image,
  instagram_status,
  instagram_main_status
) => {
  let data = new FormData()
  data.append('instagram_ID', instagram_ID)
  data.append('instagram_title', instagram_title)
  data.append('instagram_link', instagram_link)
  data.append('instagram_main_image', instagram_main_image)
  data.append('instagram_status', instagram_status)
  data.append('instagram_main_status', instagram_main_status)

  try {
    const response = await Axios.post(
      `${base_url}main/update_instagram`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_instagram_order = async (
  instagram_order_array
) => {
  let data = new FormData()

  data.append('instagram_order_array', JSON.stringify(instagram_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_instagram_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_instagram = async (
  instagram_ID_array
) => {
  let data = new FormData()
  data.append('instagram_ID_array', instagram_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_instagram`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_top_banner_one = async (
) => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_top_banner_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_top_banner = async (
  top_banner_title,
  top_banner_status,
  top_banner_editor,
  top_banner_mobile_editor
) => {
  let data = new FormData()
  data.append('top_banner_title', top_banner_title)
  data.append('top_banner_status', top_banner_status)
  data.append('top_banner_editor', top_banner_editor)
  data.append('top_banner_mobile_editor', top_banner_mobile_editor)

  try {
    const response = await Axios.post(
      `${base_url}main/update_top_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_banner = async (
) => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_banner = async (
  banner_event_image,
  banner_props_image,
  banner_props_link,
  banner_notice_image,
  banner_notice_link,
  banner_best_image,
  banner_nfu_pick_background,
  banner_nfu_pick_image,
  banner_nfu_pick_title,
  banner_nfu_pick_sub_title,
  banner_width_image,
  banner_width_mobile_image,
  banner_width_link
) => {
  let data = new FormData()
  data.append('banner_event_image', banner_event_image)
  data.append('banner_props_image', banner_props_image)
  data.append('banner_props_link', banner_props_link)
  data.append('banner_notice_image', banner_notice_image)
  data.append('banner_notice_link', banner_notice_link)
  data.append('banner_best_image', banner_best_image)
  data.append('banner_nfu_pick_background', banner_nfu_pick_background)
  data.append('banner_nfu_pick_image', banner_nfu_pick_image)
  data.append('banner_nfu_pick_title', banner_nfu_pick_title)
  data.append('banner_nfu_pick_sub_title', banner_nfu_pick_sub_title)
  data.append('banner_width_image', banner_width_image)
  data.append('banner_width_mobile_image', banner_width_mobile_image)
  data.append('banner_width_link', banner_width_link)

  try {
    const response = await Axios.post(
      `${base_url}main/update_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const check_user_cart_list = async (
  customer_ID_use_cart_list
) => {
  let data = new FormData()
  data.append('customer_ID_use_cart_list', customer_ID_use_cart_list)

  try {
    const response = await Axios.post(
      `${base_url}user/check_user_cart_list`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_cart_list = async (
  customer_ID_use_cart_list,
  cart_list_array
) => {
  let data = new FormData()
  data.append('customer_ID_use_cart_list', customer_ID_use_cart_list)
  data.append('cart_list_array', cart_list_array)

  try {
    const response = await Axios.post(
      `${base_url}user/insert_cart_list`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_cart_list = async (
  customer_ID_use_cart_list,
  cart_list_array
) => {
  let data = new FormData()
  data.append('customer_ID_use_cart_list', customer_ID_use_cart_list)
  data.append('cart_list_array', cart_list_array)

  try {
    const response = await Axios.post(
      `${base_url}user/update_cart_list`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_recent_cart_list = async (
  cart_list_array
) => {
  let data = new FormData()
  data.append('cart_list_array', cart_list_array)

  try {
    const response = await Axios.post(
      `${base_url}user/update_recent_cart_list`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_coupon = async () => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}user/get_coupon`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_coupon_one = async (coupon_ID) => {
  let data = new FormData()
  data.append('coupon_ID', coupon_ID)

  try {
    const response = await Axios.post(
      `${base_url}user/get_coupon_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_coupon_customer = async (customer_ID_use_coupon) => {
  let data = new FormData()
  data.append('customer_ID_use_coupon', customer_ID_use_coupon)

  try {
    const response = await Axios.post(
      `${base_url}user/get_coupon_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_coupon_customer_not_use = async (customer_ID_use_coupon) => {
  let data = new FormData()
  data.append('customer_ID_use_coupon', customer_ID_use_coupon)

  try {
    const response = await Axios.post(
      `${base_url}user/get_coupon_customer_not_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_coupon = async (
  payload
) => {
  let data = new FormData()
  data.append('customerIDUseCoupon', payload.customerIDUseCoupon)
  data.append('couponName', payload.couponName)
  data.append('couponDiscountType', payload.couponDiscountType)
  data.append('couponDiscountValue', payload.couponDiscountValue)
  data.append('couponMinOrderAmount', payload.couponMinOrderAmount)
  data.append('couponValidFrom', payload.couponValidFrom)
  data.append('couponValidUntil', payload.couponValidUntil)

  try {
    const response = await Axios.post(
      `${base_url}user/insert_coupon`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_coupon = async (
  coupon_ID,
  payload
) => {
  let data = new FormData()
  data.append('coupon_ID', coupon_ID)
  data.append('customerIDUseCoupon', payload.customerIDUseCoupon)
  data.append('couponName', payload.couponName)
  data.append('couponDiscountType', payload.couponDiscountType)
  data.append('couponDiscountValue', payload.couponDiscountValue)
  data.append('couponMinOrderAmount', payload.couponMinOrderAmount)
  data.append('couponValidFrom', payload.couponValidFrom)
  data.append('couponValidUntil', payload.couponValidUntil)

  try {
    const response = await Axios.post(
      `${base_url}user/update_coupon`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_coupon = async (
  coupon_ID_array
) => {
  let data = new FormData()
  data.append('coupon_ID_array', coupon_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}user/delete_coupon`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}
export const get_news = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}menu/get_news`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_news_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}menu/get_news_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_news_one = async (
  news_ID
) => {
  let data = new FormData()
  data.append('news_ID', news_ID)
  try {
    const response = await Axios.post(
      `${base_url}menu/get_news_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_news = async (
  news_title,
  news_sub_title,
  news_main_image,
  news_editor,
  news_editor_mobile,
  news_status
) => {
  let data = new FormData()
  data.append('news_title', news_title)
  data.append('news_sub_title', news_sub_title)
  data.append('news_main_image', news_main_image)
  data.append('news_editor', news_editor)
  data.append('news_editor_mobile', news_editor_mobile)
  data.append('news_status', news_status)

  try {
    const response = await Axios.post(
      `${base_url}menu/insert_news`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_news = async (
  news_ID,
  news_title,
  news_sub_title,
  news_main_image,
  news_editor,
  news_editor_mobile,
  news_status
) => {
  let data = new FormData()
  data.append('news_ID', news_ID)
  data.append('news_title', news_title)
  data.append('news_sub_title', news_sub_title)
  data.append('news_main_image', news_main_image)
  data.append('news_editor', news_editor)
  data.append('news_editor_mobile', news_editor_mobile)
  data.append('news_status', news_status)

  try {
    const response = await Axios.post(
      `${base_url}menu/update_news`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_news_order = async (
  news_order_array
) => {
  let data = new FormData()

  data.append('news_order_array', JSON.stringify(news_order_array))
  try {
    const response = await Axios.post(
      `${base_url}menu/update_news_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_news = async (
  news_ID_array
) => {
  let data = new FormData()
  data.append('news_ID_array', news_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}menu/delete_news`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_order = async (
  customer_ID_use_order,
  order_receive_name,
  order_zip_code,
  order_road_address,
  order_detail_address,
  order_big_area,
  order_small_area,
  order_phone_number,
  order_email,
  order_message,
  order_password,
  order_expected_payment_amount,
  order_payment_amount,
  order_method,
  order_depositor_name,
  order_cash_receipt_request,
  order_cash_receipt_status,
  order_cash_receipt_request_number,
  order_privacy_status,
  order_service_agreement_status,
  imp_uid,
  merchant_uid,
  buyListData,
  coupon_ID
) => {
  let data = new FormData()
  data.append('customer_ID_use_order', customer_ID_use_order)
  data.append('order_receive_name', order_receive_name)
  data.append('order_zip_code', order_zip_code)
  data.append('order_road_address', order_road_address)
  data.append('order_detail_address', order_detail_address)
  data.append('order_big_area', order_big_area)
  data.append('order_small_area', order_small_area)
  data.append('order_phone_number', order_phone_number)
  data.append('order_email', order_email)
  data.append('order_message', order_message)
  data.append('order_password', order_password)
  data.append('order_expected_payment_amount', order_expected_payment_amount)
  data.append('order_payment_amount', order_payment_amount)
  data.append('order_method', order_method)
  data.append('order_depositor_name', order_depositor_name)
  data.append('order_cash_receipt_request', order_cash_receipt_request)
  data.append('order_cash_receipt_status', order_cash_receipt_status)
  data.append('order_cash_receipt_request_number', order_cash_receipt_request_number)
  data.append('order_privacy_status', order_privacy_status)
  data.append('order_service_agreement_status', order_service_agreement_status)
  data.append('imp_uid', imp_uid)
  data.append('merchant_uid', merchant_uid)
  data.append('order_buy_list', buyListData)
  data.append('coupon_ID', coupon_ID)

  try {
    const response = await Axios.post(
      `${base_url}order/insert_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_order_one = async (order_ID) => {
  let data = new FormData()
  data.append('order_ID', order_ID)

  try {
    const response = await Axios.post(
      `${base_url}order/get_order_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_order = async () => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}order/get_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_order_non_member = async (
  order_receive_name,
  order_phone_number,
  start_date,
  end_date,
  main_tab
) => {
  let data = new FormData()
  data.append('order_receive_name', order_receive_name)
  data.append('order_phone_number', order_phone_number)
  data.append('start_date', start_date)
  data.append('end_date', end_date)
  data.append('main_tab', main_tab)

  try {
    const response = await Axios.post(
      `${base_url}order/get_order_non_member`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_order_customer_ID = async (
  customer_ID_use_order,
  start_date,
  end_date,
  main_tab
) => {
  let data = new FormData()
  data.append('customer_ID_use_order', customer_ID_use_order)
  data.append('start_date', start_date)
  data.append('end_date', end_date)
  data.append('main_tab', main_tab)

  try {
    const response = await Axios.post(
      `${base_url}order/get_order_customer_ID`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_order = async (
  order_ID,
  order_receive_name,
  order_zip_code,
  order_road_address,
  order_detail_address,
  order_big_area,
  order_small_area,
  order_phone_number,
  order_email,
  order_memo,
  order_cancle_request_status,
  order_check_request_status,
  order_buy_list
) => {
  let data = new FormData()
  data.append('order_ID', order_ID)
  data.append('order_receive_name', order_receive_name)
  data.append('order_zip_code', order_zip_code)
  data.append('order_road_address', order_road_address)
  data.append('order_detail_address', order_detail_address)
  data.append('order_big_area', order_big_area)
  data.append('order_small_area', order_small_area)
  data.append('order_phone_number', order_phone_number)
  data.append('order_email', order_email)
  data.append('order_memo', order_memo)
  data.append('order_cancle_request_status', order_cancle_request_status)
  data.append('order_check_request_status', order_check_request_status)
  data.append('order_buy_list', order_buy_list)

  try {
    const response = await Axios.post(
      `${base_url}order/update_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_recent_buy_list = async (
  buy_list_array
) => {
  let data = new FormData()
  data.append('buy_list_array', buy_list_array)

  try {
    const response = await Axios.post(
      `${base_url}order/update_recent_buy_list`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_order_complete = async (
  order_ID,
  order_expected_payment_amount
) => {
  let data = new FormData()
  data.append('order_ID', order_ID)
  data.append('order_expected_payment_amount', order_expected_payment_amount)

  try {
    const response = await Axios.post(
      `${base_url}order/update_order_complete`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_order_cancle = async (
  order_ID,
  before_order_pay_status,
  order_payment_amount
) => {
  let data = new FormData()
  data.append('order_ID', order_ID)
  data.append('before_order_pay_status', before_order_pay_status)
  data.append('order_payment_amount', order_payment_amount)

  try {
    const response = await Axios.post(
      `${base_url}order/update_order_cancle`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_order_cancle_card = async (
  order_ID,
  before_order_pay_status,
  order_payment_amount,
  imp_uid
) => {
  let data = new FormData()
  data.append('order_ID', order_ID)
  data.append('before_order_pay_status', before_order_pay_status)
  data.append('order_payment_amount', order_payment_amount)
  data.append('imp_uid', imp_uid)

  try {
    const response = await Axios.post(
      `${base_url}order/update_order_cancle_card`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_order_cancle_request_status = async (
  order_ID,
  order_cancle_request_status
) => {
  let data = new FormData()
  data.append('order_ID', order_ID)
  data.append('order_cancle_request_status', order_cancle_request_status)

  try {
    const response = await Axios.post(
      `${base_url}order/update_order_cancle_request_status`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_order_check_request_status = async (
  order_ID,
  order_check_request_status
) => {
  let data = new FormData()
  data.append('order_ID', order_ID)
  data.append('order_check_request_status', order_check_request_status)

  try {
    const response = await Axios.post(
      `${base_url}order/update_order_check_request_status`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_popup_list = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_popup_list`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_popup_one = async (popup_id) => {
  let data = new FormData()
  data.append('popup_id', popup_id)

  try {
    const response = await Axios.post(
      `${base_url}main/get_popup_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_popup_use = async () => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}main/get_popup_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const create_popup = async (formData) => {
  try {
    const response = await Axios.post(
      `${base_url}main/insert_popup`,
      formData,
      {
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
    throw err
  }
}
export const update_popup = async (formData) => {
  try {
    const response = await Axios.post(
      `${base_url}main/update_popup`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: true }
    )
    return response.data
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const update_popup_order = async (popup_order_array) => {
  let data = new FormData()
  data.append('popup_order_array', JSON.stringify(popup_order_array))

  try {
    const response = await Axios.post(
      `${base_url}main/update_popup_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_popup = async (popup_id_array) => {
  let data = new FormData()
  data.append('popup_id_array', popup_id_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_popup`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export default{
  defaultFunction
}
</script>



// WEBPACK FOOTER //
// src/components/ETC/Axios.vue